<template>
    <div v-if="initials.length" :class="[sizeClasses, variantClasses]" class="rounded-full grid content-center justify-center text-white">
        {{ initials }}
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { User } from '@/types';

export default defineComponent({
    props: {
        user: {
            type: Object as () => null | User,
            default: null,
        },
        size: {
            type: String as () => 'default' | 'lg',
            default: 'default',
        },
        variant: {
            type: String as () => 'outline' | 'filled',
            default: 'outline',
        },
    },
    computed: {
        initials(): string {
            return `${this.user?.first_name[0] || ''}${this.user?.last_name[0] || ''}`;
        },
        sizeClasses(): string {
            return this.size === 'lg' ? 'w-12 h-12 text-base' : 'w-9 h-9 text-sm';
        },
        variantClasses(): string {
            return this.variant === 'filled' ? 'bg-primary-800' : 'border-solid border-2 border-light-blue-500';
        },
    },
});
</script>
